import { render } from "./SaveProjectAllocation.vue?vue&type=template&id=3b42a181&scoped=true"
import script from "./SaveProjectAllocation.vue?vue&type=script&lang=js"
export * from "./SaveProjectAllocation.vue?vue&type=script&lang=js"

import "./SaveProjectAllocation.vue?vue&type=style&index=0&id=3b42a181&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b42a181"]])

export default __exports__